import type {ComponentProps, ComponentType} from 'react';
import {useMemo} from 'react';
import {
  Conversation,
  InlineDataConversationMessage,
} from '@stripe-internal/conversations-client';
import {LiveAnswersRow} from '../../../Chat/Row/LiveAnswersRow';

type Props = {
  conversation: Conversation;
  message: InlineDataConversationMessage;
  LiveAnswersRowComponent?: ComponentType<
    ComponentProps<typeof LiveAnswersRow>
  >;
};

export function InlineDataMessageLiveAnswersRow({
  conversation,
  message,
  LiveAnswersRowComponent: RowComponent = LiveAnswersRow,
}: Props) {
  const {liveAnswersMessage, liveAnswersClient, onDoneStreaming, onError} =
    useMemo(() => {
      return conversation.streamLiveAnswersMessage(message);
    }, [conversation, message]);

  const {data: liveAnswersData} = liveAnswersMessage;
  const liveAnswersMessageDone =
    liveAnswersData?.is_complete ||
    liveAnswersData?.was_halted ||
    liveAnswersData?.not_answerable;

  if (message.inlineData.isDone && !liveAnswersMessageDone) {
    // This indicates an error state. For the inline data to be marked done but the
    // data is not completed streaming, that means something went wrong.
    return null;
  }

  const isDone = message.inlineData.isDone || !!liveAnswersMessageDone;

  return (
    <RowComponent
      conversation={conversation}
      liveAnswersMessage={liveAnswersMessage}
      liveAnswersClient={liveAnswersClient}
      onDoneStreaming={onDoneStreaming}
      onError={onError}
      isDone={isDone}
    />
  );
}
